import { TypographyColor } from 'melp-design/components';
import { CommentStatus } from './comments.types';

export const COLOR_BY_STATUS: Record<CommentStatus, TypographyColor> = {
  visible: 'success',
  hidden: 'textSecondary',
};
